<script>
    import ApiClient from './scripts/apiclient';
    import { mapMultiSelectMode, mapRequested, mapTaskInProgress } from './stores/stores';

    export let user;
    $: showDebug = false;

    $: buttonsDisabled = $mapMultiSelectMode ? 'disabled' : null;

    export let goToStartingPosition;
    export let setStartingPosition;
    export let setPosition;
    export let logout;
    export let addPlayground;

    async function makeTestData() {
        let playground = await ApiClient.createPlayground({
            name: 'Test!',
            description: 'En testlekplats',
            features: [0, 1, 2, 3],
            location: {
                type: 'Point',
                coordinates: [13.1685208363636, 55.7295400818182],
            },

            state: 'draft',
        });

        ApiClient.createEdit(playground, {
            ...playground,
            name: 'Flap flap',
        });
    }

    async function goToMyPosition() {
        let getMessage = (code) => {
            switch (code) {
                case GeolocationPositionError.PERMISSION_DENIED:
                    return 'Position nekades';

                case GeolocationPositionError.POSITION_UNAVAILABLE:
                    return 'Position inte tillgänglig';

                case GeolocationPositionError.TIMEOUT:
                    return 'Åtgärden tog för lång tid';
            }

            return 'Okänt fel';
        };

        let error = (err) => {
            alert(`Fel: ${getMessage(err.code)}`);
        };

        let success = (pos) => {
            if (!setPosition) {
                return;
            }

            if (!pos) {
                return alert('Ingen position');
            }

            if (!pos.coords) {
                return alert('Inga koordinater');
            }

            setPosition({
                lat: pos.coords.latitude,
                lon: pos.coords.longitude,
            });
        };

        navigator.geolocation.getCurrentPosition(success, error);
    }

    function toggleMode() {
        $mapMultiSelectMode = !$mapMultiSelectMode;
    }

    /**
     * Swaps between the inbox and the map on a narrow screen, where there is only room to
     * show one of them.
     */
    function toggleMap() {
        $mapRequested = !$mapRequested;
    }
</script>

<header>
    <img
        class="float-left logo"
        srcset="/assets/apple-touch-icon-57x57.png 1x, /assets/apple-touch-icon-114x114.png 2x"
        src="/assets/apple-touch-icon-114x114.png"
        width="35"
        height="35"
        alt="Logga - Ett stiliserat barn som gungar på en gunga"
    />

    <div class="button-wrapper">
        {#if showDebug}
            <button class="btn" on:click={makeTestData}>Testdata</button>
        {/if}
        {#if user}
            <!-- Only where the inbox and the map take turns for the screen. Above the
                 breakpoint both are up at once and there is nothing to swap between.
                 It steps out while something is being done on the map, since that brings
                 the map up by itself and has its own way back out. -->
            {#if !$mapTaskInProgress}
                <button class="btn d-lg-none" title={$mapRequested ? 'Visa inkorgen' : 'Visa kartan'} on:click={toggleMap}>
                    {#if $mapRequested}
                        <i class="fas fa-inbox" /> Inkorgen
                    {:else}
                        <i class="fas fa-map" /> Karta
                    {/if}
                </button>
            {/if}
            <button class="btn d-none d-lg-inline-block" title="Skapa ny lekplats" on:click={addPlayground} disabled={buttonsDisabled}><i class="fas fa-plus" /> Ny lekplats</button>
            <button class="btn" title="Markera flera lekplatser (M)" on:click={toggleMode} disabled={buttonsDisabled}><i class="fas fa-clone" /> Markera flera</button>
            <button class="btn d-none d-lg-inline-block" title="Gå till nuvarande position" on:click={goToMyPosition}><i class="fas fa-location-arrow" /></button>
            <button class="btn d-none d-lg-inline-block" title="Gå till startposition" on:click={goToStartingPosition}><i class="fas fa-house-user" /></button>
            <button class="btn dropdown-toggle d-none d-lg-inline-block" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-user-circle" />
                {user.name}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a class="dropdown-item" href="#" on:click={setStartingPosition()}>Ställ in startposition</a>
                <!-- svelte-ignore a11y-invalid-attribute -->
                <a class="dropdown-item" href="#" on:click={logout}>Logga ut</a>
            </div>
        {/if}
    </div>
</header>

<style>
    /* The height comes from the row the shell puts this in, and the top inset keeps the
       buttons out from under the status bar on a phone that draws behind it. Growing by the
       inset rather than being pinned to a height is what lets the row absorb it, so nothing
       below has to know the toolbar got taller. */
    header {
        min-height: var(--toolbar-height);
        padding: 5px;
        padding-top: calc(5px + env(safe-area-inset-top, 0px));
        background: #eee;
        border-bottom: 1px solid #444;
    }

    .logo {
        padding: 5px 0 0 5px;
    }

    .button-wrapper {
        text-align: right;
    }

    button {
        margin: 0;
    }
</style>
